import { BaseModal } from "@/components/molecules/Modals/BaseModal";
import { useState } from "react";
import { useDispatch } from "react-redux";

import { Button } from "../../components/atoms/Buttons/Button";
import { FilterButton } from "../../components/atoms/Buttons/FilterButton";
import { MultiSelectButton } from "../../components/atoms/Buttons/MultiSelectButton";
import { SmallButton } from "../../components/atoms/Buttons/SmallButton";
import { SquareIconButton } from "../../components/atoms/Buttons/SquareIconButton";
import { ClearButton } from "../../components/atoms/ClearButton/ClearButton";
import { MultiSelectDropdown } from "../../components/atoms/Dropdown/MultiSelectDropdown";
import { DropdownItem } from "../../components/atoms/Dropdown/MultiSelectDropdownItems";
import { SimpleDropdown } from "../../components/atoms/Dropdown/SimpleDropdown";
import { Input } from "../../components/atoms/InputField/Input";
import LoadingDots from "../../components/atoms/LoadingDots/LoadingDots";
import { ProTacticsBanner } from "../../components/atoms/PromoBanners/ProTacticsBanner/ProTacticsBanner";
import { RadioButton } from "../../components/atoms/RadioButton.tsx/RadioButton";
import { ToggleSwitch } from "../../components/atoms/ToggleSwitch/ToggleSwitch";
import { ChemStyleOptions } from "../../components/features/SquadBuilder/components/ChemStyleOptions/ChemStyleOptions";
import { FilterButton as FilterButtonSquadBuilder } from "../../components/features/SquadBuilder/components/FilterButton/FilterButton";
import { TopFilterBar } from "../../components/features/SquadBuilder/components/FiltersBar/FiltersBar";
import { PitchItem } from "../../components/features/SquadBuilder/components/PitchItem/PitchItem";
import { ChooseRole } from "../../components/features/SquadBuilder/components/PlayerRole/ChooseRole/ChooseRole";
import { PlayerSidePanel } from "../../components/features/SquadBuilder/components/PlayerSidePanel/PlayerSidePanel";
import { SelectManager } from "../../components/features/SquadBuilder/components/SelectManager/SelectManager";
import { FiltersSummaryMobile } from "../../components/features/SquadBuilder/components/SquadSummaryMobile/FiltersSummaryMobile";
import { SquadSummaryMobile } from "../../components/features/SquadBuilder/components/SquadSummaryMobile/SquadStatsMobile";
import { TacticSummaryMobile } from "../../components/features/SquadBuilder/components/SquadSummaryMobile/TacticSummaryMobile";
import { SuggestSquadsButton } from "../../components/features/SquadBuilder/components/SuggestSquadsButton/SuggestSquadsButton";
import { CheckboxRow } from "../../components/molecules/CheckboxRow/CheckboxRow";
import { RangeFilter } from "../../components/molecules/Filters/RangeFilter";
import { SelectorFilter } from "../../components/molecules/Filters/SelectorFilter";
import { MetaRatingAndChemistry } from "../../components/molecules/MetaRatingAndChemistry/MetaRatingAndChemistry";
import { LoadingModal } from "../../components/molecules/Modals/SpecificModals/LoadingModal";
import { Alert } from "../../components/molecules/Notifications/Alert/Alert";
import { PlayerPlaceHolder } from "../../components/molecules/PlayerPlaceHolder/PlayerPlaceHolder";
import { ScopeSelector } from "../../components/molecules/ScopeSelector/ScopeSelector";
import { SortByMetaRatingOrChemistry } from "../../components/molecules/SortByMetaRatingOrChemistry/SortByMetaRatingOrChemistry";
import { PlayerFilters } from "../../components/organisms/Filters/PlayerFilters/PlayerFilters";
import { Rating } from "../../components/organisms/SbcView/Rating";
import { PitchButton } from "../../components/organisms/SquadBuilder/PitchButtons/PitchButton";
import { PitchButtons } from "../../components/organisms/SquadBuilder/PitchButtons/PitchButtons";
import { CustomFilterSection } from "../../components/organisms/SquadBuilder/PlayerFilters/CustomFilterSection";
import {
  filledFilterIcon,
  flagIcon,
  loadIcon,
  plusIcon,
  saveIcon,
  shareIcon,
} from "../../designSystemIcons";
import { convertPlayerPrice } from "../../functions/convertPlayerPrice";
import {
  chemistryIcon,
  detailedPlayerIcon,
  evolutionsIcon,
  filterIcon,
  owned,
  roleIcon,
} from "../../icons";
import { showModal } from "../../redux/message/messageSlice";
import { BASIC_CHEMSTYLE } from "../../redux/squadBuilder/squadBuilderUtils";
import { AppDispatch } from "../../redux/store";

export const Components = () => {
  const dispatch = useDispatch<AppDispatch>();

  const [loadingSuggestSquads, setLoadingSuggestSquads] = useState(false);
  const [minAcceleration, setMinAcceleration] = useState<number | null>(null);
  const [maxAcceleration, setMaxAcceleration] = useState<number | null>(null);
  const [optionsSelected, setOptionsSelected] = useState<boolean[]>([
    false,
    false,
    false,
    false,
    false,
  ]);
  const [evoActive, setEvoActive] = useState(false);
  const [upvoted, setUpvoted] = useState(false);
  const [downvoted, setDownvoted] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showPlaystylesDropdown, setShowPlaystylesDropdown] = useState(false);
  const [selectedCount, setSelectedCount] = useState(0);
  const [filterButtonActive, setFilterButtonActive] = useState(false);
  const [filterButtonActive2, setFilterButtonActive2] = useState(false);
  const [filterButtonActive3, setFilterButtonActive3] = useState(false);
  const [checked, setChecked] = useState(false);
  const [activeScope, setActiveScope] = useState<"market" | "both" | "club">(
    "market",
  );
  const dropdownItems = ["4-0-1", "4-0-4", "5-0-0", "4-2-9", "2-0-0"];
  const [selectedCountries, setSelectedCountries] = useState<number[]>([]);
  const [countrySearch, setCountrySearch] = useState("");

  const [selectedChemStyle, setSelectedChemStyle] = useState(BASIC_CHEMSTYLE);
  const [showLoadingModal, setShowLoadingModal] = useState(false);
  const [activePlayerFocus, setActivePlayerFocus] = useState(0);
  const countries = [
    {
      text: "Brazil",
      icon: (
        <img
          className="h-4 my-auto"
          src={`${
            import.meta.env.VITE_APP_ASSETS_BASE_URL
          }/fc24/countries/54.png`}
          alt="Brazil"
        />
      ),
      id: 54,
    },
    {
      text: "Argentina",
      icon: (
        <img
          className="h-4 my-auto"
          src={`${
            import.meta.env.VITE_APP_ASSETS_BASE_URL
          }/fc24/countries/52.png`}
          alt="Argentina"
        />
      ),
      id: 52,
    },
    {
      text: "England",
      icon: (
        <img
          className="h-4 my-auto"
          src={`${
            import.meta.env.VITE_APP_ASSETS_BASE_URL
          }/fc24/countries/14.png`}
          alt="England"
        />
      ),
      id: 14,
    },
    {
      text: "France",
      icon: (
        <img
          className="h-4 my-auto"
          src={`${
            import.meta.env.VITE_APP_ASSETS_BASE_URL
          }/fc24/countries/18.png`}
          alt="France"
        />
      ),
      id: 18,
    },
    {
      text: "Germany",
      icon: (
        <img
          className="h-4 my-auto"
          src={`${
            import.meta.env.VITE_APP_ASSETS_BASE_URL
          }/fc24/countries/21.png`}
          alt="Germany"
        />
      ),
      id: 21,
    },
  ];
  const [countryDropdownItems, setCountryDropdownItems] =
    useState<DropdownItem[]>(countries);
  const [selectedDropdownItem, setSelectedDropdownItem] = useState(0);
  const [inputTxt, setInputTxt] = useState("");
  const [sortBy, setSortBy] = useState<"meta-rating" | "chemistry">(
    "meta-rating",
  );
  const [radioButtonSelected, setRadioButtonSelected] = useState(false);
  const [country, setCountry] = useState(54);
  const [league, setLeague] = useState(1);

  return (
    <div className={"flex text-white w-full"}>
      <div className="mx-auto flex flex-col space-y-4 bg-primary-medium p-4 pb-[600px] w-full">
        <BaseModal
          title="Base Modal"
          type="info"
          description="In order to use this feature you need to have a Premium subscription"
          onClose={() => {}}
        >
          <></>
        </BaseModal>{" "}
        <BaseModal
          title="Base Modal"
          type="info"
          description="In order to use this feature you need to have a Premium subscription"
          onClose={() => {}}
          showCloseButton={true}
        >
          <></>
        </BaseModal>{" "}
        <BaseModal
          title="You discovered a Premium feature"
          type="action"
          description="In order to use this feature you need to have a Premium subscription"
          actions={[
            { label: "Cancel", onClick: () => {}, variant: "negative" },
            { label: "Confirm", onClick: () => {}, variant: "positive" },
          ]}
          onClose={() => {}}
        >
          <></>
        </BaseModal>
        <table className="min-w-full table-auto border-collapse text-center">
          <thead className="bg-gray-500">
            <tr>
              <th className="px-4 py-2 text-left font-medium">Player</th>
              <th className="px-4 py-2 font-medium">Rating</th>
              <th className="px-4 py-2 font-medium">Meta Rating</th>
              <th className="px-4 py-2 font-medium">Position</th>
              <th className="px-4 py-2 font-medium">Version</th>
              <th className="px-4 py-2 font-medium">Price</th>
              <th className="px-4 py-2 font-medium">Profit</th>
              <th className="px-4 py-2 font-medium">Properties</th>
            </tr>
          </thead>
          <tbody>
            <tr className="border-b">
              <td className="px-4 py-2 mx-auto text-left">
                Gianluigi Donnarumma
              </td>
              <td className="px-4 py-2 mx-auto">89</td>
              <td className="px-4 py-2 mx-auto">89.1</td>
              <td className="px-4 py-2 mx-auto">GK</td>
              <td className="px-4 py-2 mx-auto">Rare</td>
              <td className="px-4 py-2 mx-auto">18,250</td>
              <td className="px-4 py-2 mx-auto">-</td>
              <td className="px-4 py-2 mx-auto">...</td>
            </tr>
            {/* ... more rows ... */}
          </tbody>
        </table>
        <div className="flex flex-col mx-auto gap-y-2">
          <PlayerFilters
            hiddenFilters={[]}
            parentRoute="players"
            filters={[
              {
                type: "RANGE_FILTER",
                label: "Price",
                key: "price",
                range: [0, 9999999],
                minValue: null,
                maxValue: null,
              },
              {
                type: "RANGE_FILTER",
                label: "Rating",
                key: "rating",
                range: [0, 99],
                minValue: null,
                maxValue: null,
              },
              {
                type: "RANGE_FILTER",
                label: "Meta Rating",
                key: "metaRating",
                range: [0, 100],
                minValue: null,
                maxValue: null,
              },
            ]}
            onChange={null}
            onClearFilter={null}
            disabledFilters={[]}
          />

          <div className="mx-auto text-tiny">Basic Custom Filter</div>
          <RangeFilter
            label="Acceleration"
            minValue={minAcceleration}
            maxValue={maxAcceleration}
            onChangeMin={(v) => setMinAcceleration(v)}
            onChangeMax={(v) => setMaxAcceleration(v)}
          />
          <div className="mx-auto text-tiny">Selector Custom Filter</div>
          <SelectorFilter
            label="Preferred Foot"
            options={[
              { label: "Left", selected: optionsSelected[0] },
              { label: "Right", selected: optionsSelected[1] },
            ]}
            onClear={() => setOptionsSelected([false, false])}
            onSelectOption={(i) =>
              setOptionsSelected(
                optionsSelected.map((v, j) => (i === j ? !v : v)),
              )
            }
          />
          <SelectorFilter
            label="Skills"
            options={[
              { label: "1", selected: optionsSelected[0] },
              { label: "2", selected: optionsSelected[1] },
              { label: "3", selected: optionsSelected[2] },
              { label: "4", selected: optionsSelected[3] },
              { label: "5", selected: optionsSelected[4] },
            ]}
            onClear={() => setOptionsSelected([false, false, false, false])}
            onSelectOption={(i) =>
              setOptionsSelected(
                optionsSelected.map((v, j) => (i === j ? !v : false)),
              )
            }
          />
        </div>
        <div className="flex flex-col gap-y-2 gap-x-1">
          <button
            className="flex p-2 mx-auto rounded-md bg-primary-dark-blue"
            onClick={() =>
              dispatch(showModal({ modalType: "premium-feature" }))
            }
          >
            Show Premium Feature
          </button>
          <button
            className="flex p-2 mx-auto rounded-md bg-primary-dark-blue"
            onClick={() =>
              dispatch(showModal({ modalType: "sign-in-to-subscribe" }))
            }
          >
            Show Sign in to Subscribe
          </button>
          <button
            className="flex p-2 mx-auto rounded-md bg-primary-dark-blue"
            onClick={() =>
              dispatch(showModal({ modalType: "already-subscriber" }))
            }
          >
            Show Already A Subscriber
          </button>
          <button
            className="flex p-2 mx-auto rounded-md bg-primary-dark-blue"
            onClick={() => dispatch(showModal({ modalType: "login-required" }))}
          >
            Show Login Required
          </button>
          <button
            className="flex p-2 mx-auto rounded-md bg-primary-dark-blue"
            onClick={() => dispatch(showModal({ modalType: "save-squad" }))}
          >
            Show Save Squad
          </button>

          <button
            className="flex p-2 mx-auto rounded-md bg-primary-dark-blue"
            onClick={() => dispatch(showModal({ modalType: "welcome" }))}
          >
            Show Welcome
          </button>

          <div className="w-12 h-12 mx-auto">
            <svg
              width="109"
              height="101"
              viewBox="0 0 109 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M54.3 100.6L108.6 39.1693L83.3656 0H25.4344L0 39.2925L54.3 100.6Z"
                fill="#F8ECB2"
              />
              <path
                d="M103.128 39.1691L54.3 93.6613L5.47188 39.1691L27.7375 4.59883H80.8625L103.128 39.1691Z"
                fill="black"
              />
              <path d="M34.5 61L54.5 81L74.5 61H34.5Z" fill="#F8ECB2" />
              <path
                d="M49.5 57C46.8004 55.4837 45.4163 54.3935 43.5 52C39.8324 53.1235 36.9237 53.3023 31.5 53.5C38.4223 55.0258 42.3602 55.7972 49.5 57Z"
                fill="#F8ECB2"
              />
              <path
                d="M41.5 48.5L40 44C34.608 45.8075 30.8917 45.9938 24 46C30.3432 47.4512 33.9915 48.1732 41.5 48.5Z"
                fill="#F8ECB2"
              />
              <path
                d="M39.5 41L40 36.5C31.7487 37.816 27.0665 38.1914 18.5 38C26.3245 39.9554 30.9903 40.4985 39.5 41Z"
                fill="#F8ECB2"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M80 39.5C80 49.7173 71.7173 58 61.5 58C51.2827 58 43 49.7173 43 39.5C43 29.2827 51.2827 21 61.5 21C71.7173 21 80 29.2827 80 39.5ZM45.7808 36.5C45.5965 37.4718 45.5 38.4746 45.5 39.5C45.5 41.2461 45.7797 42.9269 46.2968 44.5L51.5 46.5L55.5 43V37L51 34L45.7808 36.5ZM59.5 23.6238L63.5 28L62.5 33L57 35.5L52.5 32.5L52.1706 26.5C54.2859 24.9792 56.7875 23.962 59.5 23.6238ZM73.5 38L76.2445 33.2764C75.0917 30.5486 73.2039 28.2071 70.8295 26.5L65.5 28.5L64.5 34L68.5 38.5L73.5 38ZM72 51.573L67.5 50.5L65 45.5L68 40.5H73.5L76.7032 44.5C75.7934 47.268 74.1488 49.7026 72 51.573ZM53.3164 53.2517C55.7108 54.6796 58.5096 55.5 61.5 55.5C61.6673 55.5 61.834 55.4974 62 55.4923L64.5 51L63 46.5L57 45L53.3164 48V53.2517Z"
                fill="#F8ECB2"
              />
            </svg>
          </div>
        </div>
        <div className="flex flex-col">
          <div className="mx-auto">
            <Rating
              wasDownvoted={downvoted}
              wasUpvoted={upvoted}
              upVotes={100}
              downVotes={200}
              onUpVote={() => {
                setUpvoted((prev) => !prev);
                setDownvoted(false);
              }}
              onDownVote={() => {
                setDownvoted((prev) => !prev);
                setUpvoted(false);
              }}
            />
          </div>
        </div>
        <div className="flex flex-col mx-auto">
          <LoadingDots />
        </div>
        <div className="relative flex flex-col">
          <div className="flex">
            <button
              className="flex p-2 mx-auto rounded-md bg-primary-dark-blue"
              onClick={() => setShowDropdown((prev) => !prev)}
            >
              {showDropdown ? "Hide" : "Show"} dropdown
            </button>
            <button
              className="flex p-2 mx-auto rounded-md bg-primary-dark-blue"
              onClick={() => setShowPlaystylesDropdown((prev) => !prev)}
            >
              {showPlaystylesDropdown ? "Hide" : "Show"} play styles dropdown
            </button>
          </div>
          {showDropdown ? (
            <div className="mx-auto">
              {/* <PositionsDropdown
                onClose={() => setShowDropdown(false)}
                positions={inputPositions}
                selectedPositions={selectedPositions}
                onChange={(pos) =>
                  setSelectedPositions((prev) =>
                    prev.includes(pos)
                      ? prev.filter((p) => p !== pos)
                      : [...prev, pos]
                  )
                }
              /> */}
            </div>
          ) : (
            showPlaystylesDropdown && (
              <div className="mx-auto">
                {/* <PlaystylesDropdown
                  playStyles={playStyles}
                  selectedPlayStyles={selectedPlayStyles}
                  onChange={(id, plus) =>
                    dispatch(updateSelectedPlayStyles({ id, plus }))
                  }
                  onClose={() => setShowPlaystylesDropdown(false)}
                /> */}
              </div>
            )
          )}
        </div>
        <div className="mx-auto">
          <MultiSelectButton
            caption="Playstyles"
            onClick={() => setSelectedCount((selectedCount + 1) % 3)}
            selectedCount={selectedCount}
          />
        </div>
        <div className="grid grid-cols-4 gap-1 mx-auto">
          <Button onClick={null} size="small">
            Default
          </Button>
          <Button onClick={null} size="small" icon={filterIcon}>
            With Icon
          </Button>
          <Button onClick={null} size="small" disabled>
            Disabled
          </Button>
          <Button onClick={null} size="small" variant="secondary" disabled>
            Disabled 2
          </Button>
          <Button onClick={null}>Default</Button>
          <Button onClick={null} icon={filterIcon}>
            With Icon
          </Button>
          <Button onClick={null} disabled>
            Disabled
          </Button>
          <Button onClick={null} variant="secondary" disabled>
            Disabled 2
          </Button>
          <Button onClick={null} size="large">
            Default
          </Button>
          <Button onClick={null} size="large" icon={filterIcon}>
            With Icon
          </Button>
          <Button onClick={null} size="large" disabled>
            Disabled
          </Button>
          <Button onClick={null} size="large" variant="secondary" disabled>
            Disabled 2
          </Button>
        </div>
        <div className="flex mx-auto gap-x-2">
          <FilterButton
            onClick={() => setFilterButtonActive(!filterButtonActive)}
            icon={owned}
            active={filterButtonActive}
          >
            {`Show Only \nOwned Players`}
          </FilterButton>
          <FilterButton
            onClick={() => setFilterButtonActive2(!filterButtonActive2)}
            icon={owned}
            active={filterButtonActive2}
            disabled
          >
            {`Show Only \nOwned Players`}
          </FilterButton>
          <FilterButton
            onClick={() => setFilterButtonActive3(!filterButtonActive3)}
            icon={owned}
            active={filterButtonActive3}
          >
            {`Show Only \nOwned Players`}
          </FilterButton>
        </div>
        <div className="flex flex-col mx-auto gap-y-2">
          <Alert
            alert={{
              type: "error",
              title: "",
              description: "",
              id: "a",
            }}
            onHandleClose={function (): void {
              throw new Error("Function not implemented.");
            }}
          />
          <ToggleSwitch onChange={null} isActive={false} />
          <Button variant="secondary" size="small" onClick={null}>
            Contact us
          </Button>
          <Button
            variant="secondary"
            disabled={true}
            size="small"
            onClick={null}
          >
            Contact us
          </Button>
        </div>
        <div className="flex mx-auto">
          <MetaRatingAndChemistry
            tempPlayers={[]}
            tempManager={{
              country: 0,
              league: 0,
            }}
            chemistry={{
              teamChemistry: 0,
              playersOutOfPosition: [],
              playersChemistry: {
                positionIndex: 0,
                chemistry: 0,
              },
              summary: {
                countryCounter: {},
                leagueCounter: {},
                clubCounter: {},
              },
            }}
            metaRating={0}
            tempChemistry={{
              teamChemistry: 0,
              playersOutOfPosition: [],
              playersChemistry: {
                positionIndex: 0,
                chemistry: 0,
              },
              summary: {
                countryCounter: {},
                leagueCounter: {},
                clubCounter: {},
              },
            }}
            tempMetaRating={0}
          />
        </div>
        <div className="flex flex-col items-center mt-6 gap-y-6">
          <CheckboxRow
            label={"Show recommended player roles"}
            checked={checked}
            onClick={() => setChecked((prev) => !prev)}
          />
          <ScopeSelector
            active={activeScope}
            onClick={(scope) => setActiveScope(scope)}
          />
          <PlayerPlaceHolder onClick={() => undefined} />
          <div className="flex flex-col w-64 gap-y-4">
            <SimpleDropdown
              items={dropdownItems}
              selectedItem={selectedDropdownItem}
              onSelect={(index) => setSelectedDropdownItem(index)}
            />
            <MultiSelectDropdown
              items={countryDropdownItems}
              placeHolder={"Country"}
              placeHolderIcon={flagIcon}
              selectedIds={selectedCountries}
              onSelect={(id) => {
                if (selectedCountries.includes(id))
                  setSelectedCountries(
                    selectedCountries.filter((c) => c !== id),
                  );
                else setSelectedCountries([...selectedCountries, id]);
              }}
              onClear={() => setSelectedCountries([])}
              searchValue={countrySearch}
              onSearchChange={(s) => {
                setCountrySearch(s);
                setCountryDropdownItems([
                  ...countries.filter((c) =>
                    c.text.toLowerCase().includes(s.toLowerCase()),
                  ),
                ]);
              }}
              setDropdownItems={setCountryDropdownItems}
            />
          </div>
          <SmallButton onClick={() => undefined}>Add Role</SmallButton>
          <FilterButtonSquadBuilder
            onClear={() => undefined}
            onClick={() => undefined}
            numberOfFilters={11}
          />
          <PitchItem />
          <ChooseRole
            onClickedAddRole={() => undefined}
            roleName={"Winger (R)"}
            roleId={"rw"}
          />
          <ClearButton onClick={() => {}} />
        </div>
        <div className="flex flex-col mx-auto">
          <span className="h-6 pl-2 text-sm text-secondary">Budget</span>
          <Input
            placeholder="Enter max team price"
            onChange={(value) => setInputTxt(value)}
          >
            {inputTxt}
          </Input>
        </div>
        <div className="flex flex-col gap-y-6 my-4 mx-auto p-8 rounded bg-[#19222c]">
          <div className="flex flex-col">
            <span className="h-6 pl-2 text-xs text-secondary-dark">
              AI Suggestions
            </span>
            <div className="w-[288px]">
              <SortByMetaRatingOrChemistry
                sortBy={sortBy}
                onChange={setSortBy}
              />
            </div>
          </div>

          <div className="w-[256px] flex flex-col gap-y-3">
            <RadioButton
              label="4-3-3"
              selected={radioButtonSelected}
              select={() => setRadioButtonSelected(true)}
            />
            <RadioButton
              label="4-3-2-1"
              selected={!radioButtonSelected}
              select={() => setRadioButtonSelected(false)}
            />
          </div>

          <div className="flex">
            <SelectManager
              onSelect={(i, type) => {
                if (type === "country") setCountry(i);
                else setLeague(i);
              }}
              country={country}
              league={league}
            />
          </div>

          <div className="flex mx-auto">
            <SuggestSquadsButton
              loading={loadingSuggestSquads}
              onClick={() => {
                setLoadingSuggestSquads(true);
                setTimeout(() => setLoadingSuggestSquads(false), 3000);
              }}
            />
          </div>
          <div className="flex mx-auto">
            <PlayerSidePanel
              onClickInsert={null}
              onClickChemstyle={null}
              onClickEvolve={null}
            />
          </div>
          <div className="flex mx-auto">
            <ChemStyleOptions
              onSelect={(s) => setSelectedChemStyle(s)}
              selected={selectedChemStyle}
              chemStyleToMetaRating={{
                250: 97.5,
                251: 84.9,
                252: 97.5,
                253: 88.3,
                254: 92.3,
                255: 88.7,
              }}
              isGoalKeeper={false}
              bestChemStyle={252}
            />
          </div>
          <div className="flex flex-col mx-auto w-96 gap-y-2">
            <div className="mx-auto text-xl">Custom Filter Section</div>
            <div className="w-full mx-auto">
              <CustomFilterSection
                disabledInGameAttributes={false}
                title="DEFENDING"
                customFilters={[
                  {
                    label: "DEFENDING",
                    onChangeMin: (val) => setMinAcceleration(val),
                    onChangeMax: (val) => setMaxAcceleration(val),
                    minValue: minAcceleration,
                    maxValue: maxAcceleration,
                  },
                  {
                    label: "Sprint Speed",
                    onChangeMax: () => null,
                    onChangeMin: () => null,
                    minValue: null,
                    maxValue: null,
                  },
                  {
                    label: "Pace",
                    onChangeMax: () => null,
                    onChangeMin: () => null,
                    minValue: null,
                    maxValue: null,
                  },
                  {
                    label: "Shot Power",
                    onChangeMax: () => null,
                    onChangeMin: () => null,
                    minValue: null,
                    maxValue: null,
                  },
                ]}
              />
            </div>
          </div>
        </div>
        {showLoadingModal && (
          <div className="relative">
            <button
              onClick={() => setShowLoadingModal(false)}
              className="fixed transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
            >
              <LoadingModal text="Building Squads..." />
            </button>
          </div>
        )}
        <div className="mx-auto bg-[#19222c] w-[500px] p-8 flex flex-col gap-y-4">
          <div className="flex mx-auto gap-x-2">
            <SquadSummaryMobile
              metaRating={99.9}
              chemistry={33}
              price={990000}
              owned={11}
              onClick={null}
              active={false}
            />
            <FiltersSummaryMobile
              formation="4-2-3-1 WIDE"
              filters={[
                "budget",
                "club",
                "country",
                "both",
                "market",
                "playerFilter",
              ]}
              onClick={null}
              active={false}
            />
            <TacticSummaryMobile
              // buildUpStyle="Short Passing"
              // defensiveApproach="High"
              // lineHeight={70}
              eaCode="12312312312"
              onClick={null}
              active={true}
            />
          </div>

          <div className="flex mx-auto gap-x-1 justify-items-stretch w-[350px]">
            <SquareIconButton
              active={false}
              onClick={null}
              disabled={false}
              icon={<div className="w-5 h-5">{roleIcon}</div>}
              text="Role"
            />
            <SquareIconButton
              active={true}
              onClick={null}
              disabled={false}
              icon={<div className="w-5 h-5">{chemistryIcon}</div>}
              text="Chemstyle"
            />
            <SquareIconButton
              active={false}
              onClick={null}
              disabled={false}
              icon={<div className="w-5 h-5">{plusIcon}</div>}
              text="Insert"
            />
            <SquareIconButton
              active={false}
              onClick={null}
              disabled={true}
              icon={<div className="w-5 h-5">{detailedPlayerIcon}</div>}
              text="Details"
            />
            <SquareIconButton
              active={false}
              onClick={null}
              disabled={false}
              icon={<div className="w-5 h-5">{evolutionsIcon}</div>}
              text="Evolve"
            />
            <SquareIconButton
              active={false}
              onClick={null}
              disabled={false}
              icon={
                <div className="w-5 h-5 text-white stroke-white fill-white">
                  {filledFilterIcon}
                </div>
              }
              text="Filter"
            />
          </div>
        </div>
        <div className="mx-auto bg-[#19222c] flex-col w-[298px] flex py-0.5 gap-y-1">
          {/* <div className="flex mx-auto gap-x-1">
            <PlayerRolePositionFocus
              playerRoleId="st"
              focus="Balanced"
              position="LW"
              columns={3}
            />
            <PlayerRolePositionFocus
              playerRole="Inside Forward"
              focus="Balanced"
              position="ST"
              columns={3}
            />
            <PlayerRolePositionFocus
              playerRole="Winger"
              focus="Balanced"
              position="RW"
              columns={3}
            />
          </div>
          <div className="flex mx-auto gap-x-1">
            <PlayerRolePositionFocus
              playerRole="Box-to-Box"
              focus="Balanced"
              position="CM"
              columns={5}
            />
            <PlayerRolePositionFocus
              playerRole="Playmaker"
              focus="Balanced"
              position="CM"
              columns={5}
            />
            <PlayerRolePositionFocus
              playerRole="Playmaker"
              focus="Balanced"
              position="CM"
              columns={5}
            />
            <PlayerRolePositionFocus
              playerRole="Box-to-Box"
              focus="Balanced"
              position="CM"
              columns={5}
            />
            <PlayerRolePositionFocus
              playerRoleId="rat"
              focus="Balanced"
              position="CM"
              columns={5}
            />
          </div> */}

          <div className="mx-auto">
            <TopFilterBar
              filters={[
                { key: "budget", value: convertPlayerPrice(1999000, true) },
                { key: "market", value: "-" },
                { key: "country", value: "2" },
                { key: "league", value: "99+" },
                { key: "playerFilter", value: "11" },
              ]}
              onClearFilter={() => null}
            />
          </div>
        </div>
        <PitchButtons>
          <PitchButton
            loading={false}
            disabled={false}
            onClick={function (): void {
              throw new Error("Function not implemented.");
            }}
            label={"Import Squad"}
            icon={loadIcon}
          />
          <PitchButton
            loading={false}
            disabled={false}
            onClick={function (): void {
              throw new Error("Function not implemented.");
            }}
            label={"Share"}
            icon={shareIcon}
          />
          <PitchButton
            loading={false}
            disabled={true}
            onClick={function (): void {
              throw new Error("Function not implemented.");
            }}
            label={"Save"}
            icon={saveIcon}
          />
        </PitchButtons>
        {/*<div className="mx-auto w-[240px] flex gap-x-2">*/}
        {/*  <PlayerFocus*/}
        {/*    onClick={() => setActivePlayerFocus(0)}*/}
        {/*    active={activePlayerFocus === 0}*/}
        {/*    position="cam"*/}
        {/*    playerRole="playmaker"*/}
        {/*    focus="roaming"*/}
        {/*  />*/}
        {/*  <PlayerFocus*/}
        {/*    onClick={() => setActivePlayerFocus(1)}*/}
        {/*    active={activePlayerFocus === 1}*/}
        {/*    position="lb"*/}
        {/*    playerRole="falseback"*/}
        {/*    focus="balanced"*/}
        {/*  />*/}
        {/*  <PlayerFocus*/}
        {/*    onClick={() => setActivePlayerFocus(2)}*/}
        {/*    active={activePlayerFocus === 2}*/}
        {/*    position="rb"*/}
        {/*    playerRole="fullback"*/}
        {/*    focus="defend"*/}
        {/*  />*/}
        {/*</div>*/}
        <ProTacticsBanner />
      </div>
    </div>
  );
};

export default Components;
